import {useHistory} from "react-router-dom";
import {useRouteMatch} from "react-router";
import React, {useEffect, useState} from "react";
import {useHojasDeRutaService} from "services/hooks";
import {useSnackbar} from "notistack";
import {CardPedido} from "components/picking/components/card.pedido";
import {CardHeader} from "components/picking/components/card.header";
import Typography from "@material-ui/core/Typography";

export function SelectPedidoView(props) {
  const [pedidos, setPedidos] = useState([]);
  const history = useHistory();
  const match = useRouteMatch();
  const {enqueueSnackbar} = useSnackbar();
  const HojasDeRutaService = useHojasDeRutaService();

  const backUrlParts = props.location.pathname.split("/");
  backUrlParts.pop();
  const backScreen = backUrlParts.pop();
  const tipoEscaneo = backScreen === "validarDespachoPedido" ? 1 : 2;
  const backUrl = `${backUrlParts.join("/")}/${backScreen}`;

  useEffect(() => {
    HojasDeRutaService.getPedidosById(
      match.params.idHojaDeRuta,
      response => setPedidos(response.data.result),
      error => enqueueSnackbar(error, {variant: 'error'})
    );
  }, []);

  const navToScan = id => {
    history.push(`${match.url}/${id}`);
  }

  const pedidosDisponibles = pedidos.filter(pedido => {
    if (tipoEscaneo === 2) return pedido.escaneado1;
    return true;
  })

  return (
    <div>
      <CardHeader
        backUrl={`${backUrl}`}
        textLeft={'Hoja de Ruta: ' + match.params.idHojaDeRuta}
        textRight={pedidos.length + ' pedidos'}
      />
      {tipoEscaneo === 2 && pedidosDisponibles.length <= 0 && (
        <Typography variant="body1" align={"center"} className={"mt-4"}>Debe validar algún pedido para despacho</Typography>
      )}
      {pedidosDisponibles
        .map((pedido, index) =>
          <CardPedido
            key={index}
            id={pedido.id}
            fecha={pedido.fecha}
            cliente={pedido.cliente}
            tipoEscaneo={tipoEscaneo}
            escaneado1={pedido.escaneado1}
            escaneado2={pedido.escaneado2}
            onClick={() => navToScan(pedido.id)}
          />
        )}
    </div>
  )
}
